const cryptoOptions = [
  {
    value: "BTC",
    label: "Bitcoin",
    flag: "https://assets.coingecko.com/coins/images/1/thumb/bitcoin.png",
    networks: ["Bitcoin"],
  },
  {
    value: "ETH",
    label: "Ethereum",
    flag: "https://assets.coingecko.com/coins/images/279/thumb/ethereum.png",
    networks: ["Ethereum"],
  },
  {
    value: "USDT",
    label: "Tether",
    flag: "https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png",
    networks: ["ERC-20", "TRC-20", "BEP-20", "Polygon"],
  },
  {
    value: "TRON",
    label: "TRON",
    flag: "https://assets.coingecko.com/coins/images/1094/thumb/tron-logo.png",
    networks: ["TRX"],
  },
  {
    value: "BNB",
    label: "Binance Coin",
    flag: "https://assets.coingecko.com/coins/images/825/thumb/binance-coin-logo.png",
    networks: [" BEP-20"],
  },
  {
    value: "USDC",
    label: "USD Coin",
    flag: "https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png",
    networks: ["ERC-20", "TRC-20", "BEP-20", "Polygon"],
  },
  {
    value: "XRP",
    label: "Ripple",
    flag: "https://assets.coingecko.com/coins/images/44/thumb/xrp-symbol-white-128.png",
    networks: ["Ripple"],
  },

  {
    value: "MATIC",
    label: "Polygon",
    flag: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png",
    networks: ["ERC-20", "Polygon"],
  },
];

export default cryptoOptions;
